import { render, staticRenderFns } from "./WayBillList.vue?vue&type=template&id=0acc01ba&scoped=true"
import script from "./WayBillList.vue?vue&type=script&lang=js"
export * from "./WayBillList.vue?vue&type=script&lang=js"
import style0 from "./WayBillList.vue?vue&type=style&index=0&id=0acc01ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acc01ba",
  null
  
)

export default component.exports
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QExpansionItem,QCard,QCardSection,QBanner,QInput,QChip,QBadge,QBtn,QTooltip,QPopupProxy,QCardActions,QTable,QTr,QTd,QSpace,QDialog});qInstall(component, 'directives', {ClosePopup});
